"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addModal = void 0;
const react_1 = __importDefault(require("react"));
const effects_1 = require("redux-saga/effects");
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const next_app_controller_reducers_sagas_main_reducer_n_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n");
const next_components_modal_1 = __importDefault(require("@gerenciatd/next.components.modal"));
const filePath = 'sagas/modals-saga-n/add-modal';
let modalCssLoaded = false;
let startedModalListener = false;
const modalDelimiter = `${process.env.NEXT_PUBLIC_MODAL_DELIMITER}`;
const composeIdByType = (id) => {
    let id2Use = id;
    const noHasAnchorTag = id.indexOf('#') === -1;
    if (noHasAnchorTag) {
        id2Use = `#${id}`;
    }
    return `${id2Use}`;
};
function* addModal(data) {
    try {
        if (!modalCssLoaded) {
            try {
                modalCssLoaded = true;
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href =
                    'https://prod.cms.col.movistar.es/static/ts/next/modal.style.min.css';
                document.head.appendChild(link);
            }
            catch (err) {
                modalCssLoaded = false;
                yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
                    err,
                    filePath,
                    kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.ERROR,
                    processName: 'Error al importar css de modal dinámicamente',
                }));
            }
        }
        const { type, history } = data;
        let { id } = data;
        if (!startedModalListener) {
            startedModalListener = true;
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_modals_reducer_1.actions.initAnchorModalListener());
        }
        let lastElement2Show = null;
        const modalsHistory = (state) => state.modals.modalHistory;
        const modalHistory = yield (0, effects_1.select)(modalsHistory);
        const modalHistoryLength = modalsHistory.length;
        let lastModalHistoryId = '';
        if (modalHistory && modalHistory.length > 0 && modalHistory[(modalHistoryLength - 1)] && modalHistory[(modalHistoryLength - 1)].id) {
            lastModalHistoryId = modalHistory[(modalHistoryLength - 1)].id;
        }
        const isCurrentlyOpened = id && lastModalHistoryId && (lastModalHistoryId === id);
        // Modelamos el id que usaremos como ancla en la url
        id = composeIdByType(id, type);
        // Flag a calcular para saber si muestro u oculto modal
        let finalyShowsContent = false;
        // Flags para deducir si es nuevo contenido | volver atras | cerrar todo
        const showNewContent = id !== '#' && id !== '#closeAll';
        const closeAllContent = id === '#closeAll';
        // vemos si nos invocan con otro id diferente al anterior
        let createNavigation2 = '';
        // 1) casuistica de cerrar todo
        if (closeAllContent) {
            createNavigation2 = '#';
            finalyShowsContent = false;
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_modals_reducer_1.actions.setModalHistory([]));
        }
        // 2) creo una modal nueva
        // 2.1) me asguro de que no es la modal activa, con isCurrentlyOpened
        if (!isCurrentlyOpened && showNewContent && !closeAllContent) {
            const { Element2Show, modalProps, elementProps } = data;
            if (modalProps) {
                next_components_modal_1.default.setModalProps(modalProps);
            }
            next_components_modal_1.default.setContent(react_1.default.createElement(Element2Show, Object.assign({}, elementProps)));
            // apilo el nuevo contenido
            const newModalHistory = [...modalHistory, data];
            // yield put....
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_modals_reducer_1.actions.setModalHistory(newModalHistory));
            createNavigation2 = id;
            finalyShowsContent = true;
        }
        // 3) tengo que cerrar y tirar de historico
        if (isCurrentlyOpened || (!showNewContent && !closeAllContent)) {
            const newModalHistory = [...modalHistory];
            const newModalHistoryLength = newModalHistory && newModalHistory.length;
            const lastModalIndex = newModalHistoryLength - 2;
            // me quedo el elemento que me interesa
            lastElement2Show = newModalHistory[lastModalIndex];
            // comprobamos si solo hay una modal
            if (!lastElement2Show) {
                // limpio todo, cierro y no anclo
                // esto es para simplemente cerrar modal sin crear navegación
                createNavigation2 = '#';
                finalyShowsContent = false;
                yield (0, effects_1.put)(next_app_controller_reducers_sagas_modals_reducer_1.actions.setModalHistory([]));
            }
            else {
                const { Element2Show, elementProps, modalProps, id: lastModalId, } = lastElement2Show;
                createNavigation2 = id;
                if (Element2Show && lastModalId) {
                    next_components_modal_1.default.setModalProps(modalProps);
                    next_components_modal_1.default.setContent(react_1.default.createElement(Element2Show, Object.assign({}, elementProps)));
                    yield (0, effects_1.put)(next_app_controller_reducers_sagas_modals_reducer_1.actions.setModalHistory(newModalHistory));
                    createNavigation2 = composeIdByType(lastModalId, next_app_controller_reducers_sagas_modals_reducer_1.ELEMENT_TYPES.MODAL);
                    finalyShowsContent = true;
                    newModalHistory.pop();
                    yield (0, effects_1.put)(next_app_controller_reducers_sagas_modals_reducer_1.actions.setModalHistory(newModalHistory));
                }
            }
        }
        // El modal.show podria ir al final
        if (finalyShowsContent) {
            next_components_modal_1.default.show();
        }
        else {
            next_components_modal_1.default.hide();
        }
        // APLICAMOS NAVEGACIÓN AL HISTORY PARA NO PERDER EL PASO
        if (createNavigation2) {
            const bhistory = modalDelimiter === '#'
                ? history.createHashHistory()
                : history.createBrowserHistory();
            if (createNavigation2 === '#') {
                createNavigation2 = '';
            }
            const search = bhistory && bhistory.location && bhistory.location.search
                ? bhistory.location.search
                : '';
            const pathname = bhistory && bhistory.location && bhistory.location.pathname
                ? bhistory.location.pathname
                : '';
            const finalCompo = `${pathname}${search}${createNavigation2}`;
            if (modalDelimiter === '#') {
                if (!createNavigation2) {
                    for (let index = 0; index < modalHistory.length; index += 1) {
                        bhistory.go(-1);
                    }
                    yield (0, effects_1.put)(next_app_controller_reducers_sagas_modals_reducer_1.actions.setModalHistory([]));
                }
                else if (!lastElement2Show) {
                    bhistory.push(finalCompo);
                }
            }
            else {
                bhistory.push(finalCompo);
            }
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda({
            error,
            filePath,
            kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.ERROR,
            processName: 'addModal',
        }));
        // console.error(error);
    }
}
exports.addModal = addModal;
exports.default = addModal;
//# sourceMappingURL=index.js.map